<template>
  <section>
    <div v-if="loading">
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
          <router-link
            to="/admin/business/budgets/create"
            class="button text-white bg-theme-1 shadow-md mr-2"
          >
            Crear Presupuesto
          </router-link>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="true">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">
            Presupuesto {{ current.reference }}
          </h2>
        </div>
        <form
          class="intro-y grid grid-cols-12 gap-3 p-5"
          @submit.prevent="checkBudget"
        >
          <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
            <label>Cliente</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="current.client_id"
              required
              disabled
            >
              <option seleted value="null">Seleccione Cliente...</option>
              <option
                v-for="client in clients"
                :value="client.id"
                :key="`${client.id}-client`"
              >
                {{ client.social_reason }}
              </option>
            </select>
          </div>

          <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
            <label>Ejecutivo</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="current.ejecutive_id"
              required
              disabled
            >
              <option seleted :value="null">Seleccione Ejecutivo...</option>
              <option
                v-for="ejecutive in filteredEjecutives"
                :value="ejecutive.id"
                :key="`${ejecutive.id}-ejecutive`"
              >
                {{ ejecutive.name }} - {{ ejecutive.email }}
              </option>
            </select>
          </div>

          <div
            v-if="current.social_reason_id"
            class="mt-3 col-span-6 sm:col-span-6"
          >
            <label>Moneda cambio</label>
            <div class="input w-full border mt-2 flex-1">
              {{ current.money_code }}
            </div>
          </div>
          <div
            v-if="current.social_reason_id"
            class="mt-3 col-span-6 sm:col-span-6"
          >
            <label>1 dólar es igual a:</label>
            <div class="input w-full border mt-2 flex-1">
              {{ current.usd_convertion }}
            </div>
          </div>

          <div class="mt-3 col-span-6 sm:col-span-6">
            <label>Referencia</label>
            <input
              type="text"
              class="input w-full border mt-2"
              v-model="current.reference"
              required
              
            />
          </div>

          <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
            <label>Razon Social</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="current.social_reason_id"
              required
              @change="resetBudgetItems('social_reason_id')"
              disabled
            >
              <option seleted :value="null">Seleccione la Razon Social</option>
              <option
                v-for="socialreason in socialreasons"
                :value="socialreason.id"
                :key="`${socialreason.id}-social-reason`"
              >
                {{ socialreason.name }} - {{ socialreason.country_prefix }}
              </option>
            </select>
          </div>

          <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
            <label>Cuenta</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="current.account_id"
              required
              disabled
              @change="resetBudgetItems('account_id')"
            >
              <option seleted :value="null">Seleccione una cuenta</option>
              <option
                v-for="account in filteredAccounts"
                :value="account.id"
                :key="`${account.id}-account`"
              >
                {{ account.name }}
              </option>
            </select>
          </div>
          <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
            <label>Proyecto</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="current.project_id"
              required
              disabled
            >
              <option seleted :value="null">Seleccione un proyecto</option>
              <option
                v-for="project in filteredProjects"
                :value="project.id"
                :key="`${project.id}-project`"
              >
                {{ project.name }} - {{ project.account.name }}
                {{ project.account.country.prefix }}
              </option>
            </select>
          </div>
          <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
            <label>Campaña</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="current.campaign_id"
              required
              disabled
            >
              <option seleted :value="null">Seleccione la campaña</option>
              <option
                v-for="campaign in filteredCampaigns"
                :value="campaign.id"
                :key="`${campaign.id}-campaign`"
              >
                {{ campaign.name }}
              </option>
            </select>
          </div>

          <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
            <label>Tipo de presupuesto</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="current.type"
              required
              disabled
            >
              <option seleted value="null">Seleccione tipo</option>
              <option value="cliente">Cliente</option>
              <option value="cargo agencia">Cargo Agencia</option>
            </select>
          </div>

          <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="current.type"
              >
                <label>Comision Agencia</label>
                <input
                  type="number"
                  class="input w-full border mt-2 flex-1"
                  step=".01"
                  v-model="current.commission_agency"
                  required
                  :disabled="checked"
                />
              </div>

          <div class="col-span-12" v-if="createNewVersion">
            <div class="px-5 sm:px-8 py-5 sm:py-10">
              <div
                class="intro-y grid grid-cols-12 gap-3 py-5 bg-gray-400 rounded px-2"
                v-if="!checked"
              >
                <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
                  <label>Agregar item:</label>
                  <select
                    class="input w-full border mt-2 flex-1"
                    v-model="budgetCurrentItem.id"
                  >
                    <option seleted :value="null">Seleccione...</option>
                    <option
                      v-for="element in filteredBudgetElements"
                      :value="element.id"
                      :key="`${element.id}-budget-element`"
                    >
                      {{ element.name }} - $ {{ formatPrice(element.value) }}
                    </option>
                    <option
                      value="special"
                      v-if="filteredBudgetElements.length"
                    >
                      Nuevo Elemento
                    </option>
                  </select>
                </div>
                <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-3">
                  <label>Cantidad:</label>
                  <input
                    v-model="budgetCurrentItem.quantity"
                    type="number"
                    min="1"
                    class="input w-full border mt-2 flex-1"
                  />
                </div>
                <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-3 flex">
                  <button
                    @click="addItem()"
                    type="button"
                    class="button w-24 bg-theme-1 text-white mt-auto"
                    :disabled="!budgetCurrentItem.id"
                  >
                    Agregar
                  </button>
                </div>
              </div>

              <div class="overflow-x-auto">
                <table class="table">
                  <thead>
                    <tr class="border-b dark:border-dark-5">
                      <th class="whitespace-nowrap text-center">
                        CONCEPTO ITEM
                      </th>
                      <th class="whitespace-nowrap text-center">QTY</th>
                      <th class="whitespace-nowrap text-center">
                        VALOR UNITARIO
                      </th>
                      <th class="whitespace-nowrap text-center">IVA</th>
                      <th class="whitespace-nowrap text-center">COMISION</th>
                      <th class="whitespace-nowrap text-center">TOTAL</th>
                      <th class="whitespace-nowrap text-center">ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!budgetitems.length">
                      <th colspan="6" class="text-center">
                        No hay Elementos seleccionados
                      </th>
                    </tr>
                    <tr
                      v-for="(item, index) in budgetitems"
                      :key="`${item.name}-budget-item-${index}`"
                      class="border-b dark:border-dark-5"
                    >
                      <td>
                        <input
                          v-if="!checked"
                          class="input w-full border mt-2"
                          type="text"
                          v-model.lazy="item.name"
                        />
                        <div v-else class="font-medium whitespace-nowrap">
                          {{ item.name }}
                        </div>
                        <div class="mt-3">
                          <div class="text-left whitespace-no-wrap">
                            DESCRIPCION:
                          </div>
                          <textarea
                            v-if="!checked"
                            class="input w-full border mt-2"
                            rows="3"
                            v-model="item.description"
                          ></textarea>
                          <div v-else class="font-medium whitespace-nowrap">
                            {{ item.description }}
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <input
                          v-if="!checked"
                          v-model="item.quantity"
                          type="number"
                          class="input w-full border mt-auto flex-1"
                          min="1"
                        />
                        <div
                          v-else
                          class="font-medium whitespace-nowrap text-center"
                        >
                          {{ item.quantity }}
                        </div>
                      </td>
                      <td class="text-right">
                        <currency-input
                          :id="item.id"
                          v-if="!checked"
                          class="input w-full border mt-2"
                          v-model="item.unit_value"
                          locale="es"
                          :precision="2"
                          :valueRange="{ min: 0 }"
                          :distraction-free="{
                            hideNegligibleDecimalDigits: true,
                          }"
                          :currency="{ prefix: '$ ' }"
                          @blur="
                            item.unit_value == null ? (item.unit_value = 0) : ''
                          "
                        />
                        <div
                          v-else
                          class="font-medium whitespace-nowrap text-center"
                        >
                          ${{ formatPrice(item.unit_value) }}
                        </div>
                        <div class="mt-3">
                          <div class="text-left">SUBTOTAL:</div>
                          <div class="text-center">
                            $ {{ formatPrice(item.quantity * item.unit_value) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <select
                          v-if="!checked"
                          name=""
                          class="input w-full border mt-auto flex-1"
                          v-model="item.iva"
                        >
                          <option :value="0">0%</option>
                          <option
                            v-if="
                              selectedSocialReason && selectedSocialReason.iva
                            "
                            :value="selectedSocialReason.iva"
                          >
                            {{ selectedSocialReason.iva }}%
                          </option>
                        </select>
                        <div
                          v-else
                          class="font-medium whitespace-nowrap text-center"
                        >
                          {{ item.iva }}%
                        </div>
                        <div class="mt-3">
                          <div class="text-left whitespace-no-wrap">
                            VALOR IVA:
                          </div>
                          <div class="text-center whitespace-no-wrap">
                            $
                            {{
                              formatPrice(
                                percentCalculator(
                                  item.iva,
                                  item.quantity * item.unit_value
                                )
                              )
                            }}
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <select
                          v-if="!checked"
                          name=""
                          class="input w-full border mt-auto flex-1 text-center"
                          v-model="item.commission"
                        >
                            <option :value="0">0%</option>
                            <option :value="1">1%</option>
                            <option :value="2.5">2,5%</option>
                            <option :value="3">3%</option>
                            <option :value="3.2">3,2%</option>
                            <option :value="4">4%</option>
                            <option :value="4.2">4,2%</option>
                            <option :value="6">6%</option>
                            <option :value="7.2">7,2%</option>
                            <option :value="8">8%</option>
                        </select>
                        <div
                          v-else
                          class="font-medium whitespace-nowrap text-center"
                        >
                          {{ item.commission }}%
                        </div>
                        <div class="mt-3">
                          <div class="text-left whitespace-no-wrap">
                            VALOR COMISION:
                          </div>
                          <div class="text-center whitespace-no-wrap">
                            $
                            {{
                              formatPrice(
                                percentCalculator(
                                  item.commission,
                                  item.quantity * item.unit_value
                                )
                              )
                            }}
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="whitespace-no-wrap text-center">
                          $
                          {{
                            formatPrice(
                              item.quantity * item.unit_value +
                                percentCalculator(
                                  item.iva,
                                  item.quantity * item.unit_value,
                                  false
                                ) +
                                percentCalculator(
                                  item.commission,
                                  item.quantity * item.unit_value,
                                  false
                                )
                            )
                          }}
                        </div>
                      </td>
                      <td class="text-right">
                        <button
                          @click="budgetitems.splice(index, 1)"
                          type="button"
                          class="button bg-theme-6 text-white mt-auto"
                          v-if="!checked"
                        >
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="px-5 sm:px-20 pb-10 sm:pb-20 flex flex-col-reverse sm:flex-row"
              >
                <div class="text-center sm:text-right sm:ml-auto mt-5">
                  <div class="text-base text-gray-600">
                    Subtotal:
                    <span
                      class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                    >
                      {{ current.money_code }} $ {{ formatPrice(subtotal) }}
                    </span>
                  </div>
                  <div v-if="subtotal" class="text-base text-gray-600">
                    Subtotal:
                    <span
                      class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                    >
                      USD $ {{ formatPrice(current.usd_subtotal) }}
                    </span>
                  </div>
                  <hr class="my-4" />
                  <div class="text-base text-gray-600">
                    Impuestos subtotal:
                    <span
                      class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                    >
                      {{ current.money_code }} $ {{ formatPrice(taxSubtotal) }}
                    </span>
                  </div>
                  <div
                    v-if="current.usd_convertion"
                    class="text-base text-gray-600"
                  >
                    Impuestos subtotal:
                    <span
                      class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                    >
                      USD $
                      {{ formatPrice(taxSubtotal / current.usd_convertion) }}
                    </span>
                  </div>
                  <hr class="my-4" />
                  <div class="text-base text-gray-600">
                    Comision subtotal:
                    <span
                      class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                    >
                      {{ budget.money_code }} $
                      {{ formatPrice(commissionSubtotal) }}
                    </span>
                  </div>
                  <div
                    v-if="current.usd_convertion"
                    class="text-base text-gray-600"
                  >
                    Comision subtotal:
                    <span
                      class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                    >
                      USD $
                      {{
                        formatPrice(commissionSubtotal / current.usd_convertion)
                      }}
                    </span>
                  </div>
                  <hr class="my-4" />
                  <div
                    class="text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
                  >
                    <span class="text-gray-600">TOTAL:</span>
                    {{ current.money_code }} $ {{ formatPrice(total) }}
                  </div>
                  <div
                    v-if="total"
                    class="text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
                  >
                    <span class="text-gray-600">TOTAL: </span>
                    USD $ {{ formatPrice(current.usd_total) }}
                  </div>
                  <div class="mt-1 tetx-xs">Incluye Impuestos</div>
                </div>
              </div>
            </div>
            <div v-if="checked" class="mt-3 col-span-12">
              <button
                type="button"
                @click="createVersion()"
                class="button bg-theme-9 text-white mt-auto"
              >
                Confirmar version
              </button>
              <button
                type="button"
                @click="checked = false"
                class="button bg-theme-11 text-white mt-auto"
              >
                Editar version
              </button>
            </div>

            <div v-else class="mt-3 col-span-12">
              <button
                type="submit"
                class="button bg-theme-1 text-white mt-auto"
              >
                Crear version
              </button>
              <button
                type="button"
                class="button bg-theme-16 text-white mt-auto"
                @click="createNewVersion = !createNewVersion"
              >
                Cancelar
              </button>
            </div>
          </div>

          <div v-else class="mt-3 col-span-12">
            <button
              type="button"
              class="button bg-theme-1 text-white mt-auto"
              @click="createNewVersion = !createNewVersion"
            >
              Crear nueva version
            </button>
          </div>
        </form>
      </div>
      <!-- END: Edit -->

      <div class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3">
        <div class="intro-x flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-5">
            Historial de versiones
          </h2>
        </div>
        <div class="report-timeline mt-5 relative">
          <div
            v-for="(version, index) in current.versions"
            class="intro-x relative flex items-center mb-3"
          >
            <div class="report-timeline__image">
              <div class="flex h-10 w-10">
                <div
                  class="bg-theme-1 h-3 m-auto my-auto rounded-full w-3 z-10"
                ></div>
              </div>
            </div>
            <div class="box px-5 py-3 ml-4 flex-1 zoom-in">
              <div class="flex items-center">
                <div>
                  <div class="font-medium">
                    Version #{{ current.versions.length - index }}
                    <span v-if="!index">ACTUAL</span>
                  </div>
                  <div class="text-xs text-gray-500">
                    Usuario: {{ version.user_name }} - {{ version.user_email }}
                  </div>
                </div>
                <div class="text-xs text-gray-500 ml-auto">
                  {{ version.created_at }}
                </div>
              </div>
              <div class="flex items-center">
                <div class="accordion accordion-boxed">
                  <div class="accordion-item">
                    <div
                      v-if="version.show"
                      class="accordion-collapse collapse show"
                    >
                      <div class="overflow-auto">
                        <table class="table table-report -mt-2">
                          <thead>
                            <tr>
                              <th class="text-center whitespace-no-wrap">
                                CONCEPTO ITEM
                              </th>
                              <th class="text-center whitespace-no-wrap">
                                QTY
                              </th>
                              <th class="text-center whitespace-no-wrap">
                                PRECIO
                              </th>
                              <th class="text-center whitespace-no-wrap">
                                SUBTOTAL
                              </th>
                              <th class="text-center whitespace-no-wrap">
                                IVA
                              </th>
                              <th class="text-center whitespace-no-wrap">
                                COMISION
                              </th>
                              <th class="text-center whitespace-no-wrap">
                                TOTAL
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="intro-x"
                              v-for="(item, index) in version.items"
                              :key="`item-${item.id}-${index}`"
                            >
                              <td class="w-40 text-center">
                                <div class="text-left whitespace-no-wrap">
                                  ITEM:
                                </div>
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  {{ item.name }}
                                </div>
                                <div class="text-left whitespace-no-wrap">
                                  DESCRIPCION:
                                </div>
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  <a
                                    :data-target="`#description-${index}`"
                                    data-toggle="modal"
                                    class="text-white"
                                    >ver más</a
                                  >
                                </div>
                              </td>
                              <td class="w-40 text-center">
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  {{ item.quantity }}
                                </div>
                              </td>
                              <td class="w-40 text-center">
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  $ {{ formatPrice(item.unit_value) }}
                                </div>
                              </td>
                              <td class="w-40 text-center">
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  $ {{ formatPrice(item.subtotal) }}
                                </div>
                              </td>
                              <td class="w-40 text-center">
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  $ {{ formatPrice(item.iva_value) }}
                                </div>
                              </td>
                              <td class="w-40 text-center">
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  $ {{ formatPrice(item.commission_value) }}
                                </div>
                              </td>
                              <td class="w-40 text-center">
                                <div
                                  class="text-gray-600 text-xs whitespace-no-wrap"
                                >
                                  $ {{ formatPrice(item.total) }}
                                </div>
                              </td>
                              <!-- Modal -->
                              <div class="modal" :id="`description-${index}`">
                                <div class="modal__content modal__content--md">
                                  <div
                                    class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
                                  >
                                    <h2 class="font-medium text-base mr-auto">
                                      ITEM: {{ item.name }}
                                    </h2>
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="modal"
                                    >
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  </div>
                                  <div>
                                    <div
                                      class="p-5 grid grid-cols-12 gap-4 row-gap-3"
                                    >
                                      <div class="col-span-12 sm:col-span-12">
                                        <label>DESCRIPCION:</label>
                                        <div>{{ item.description }}</div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="px-5 py-3 text-right border-t border-gray-200"
                                  >
                                    <button
                                      type="button"
                                      data-dismiss="modal"
                                      class="button w-20 border text-gray-700 mr-1"
                                    >
                                      Cerrar
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- Modal End -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <div class="text-gray-600 mt-1 text-right">
                SUBTOTAL: $ {{ formatPrice(version.subtotal) }}
              </div>
              <div class="text-gray-600 mt-1 text-right">
                SUBTOTAL: USD $ {{ formatPrice(version.usd_subtotal) }}
              </div>
              <hr class="my-4" />
              <div class="text-gray-600 mt-1 text-right">
                IMPUESTOS: $ {{ formatPrice(version.iva) }}
              </div>
              <div class="text-gray-600 mt-1 text-right">
                IMPUESTOS: USD $ {{ formatPrice(version.usd_tax) }}
              </div>
              <hr class="my-4" />
              <div class="text-gray-600 mt-1 text-right">
                IMPUESTOS: $ {{ formatPrice(version.commission) }}
              </div>
              <div class="text-gray-600 mt-1 text-right">
                IMPUESTOS: USD $ {{ formatPrice(version.usd_commission) }}
              </div>
              <hr class="my-4" />
              <div class="text-gray-600 mt-1 text-right">
                TOTAL: $ {{ formatPrice(version.total) }}
              </div>
              <div class="text-gray-600 mt-1 text-right">
                TOTAL: USD $ {{ formatPrice(version.usd_total) }}
              </div>
              <div class="accordion-header" v-if="version.items.length">
                <button
                  class="accordion-button"
                  type="button"
                  @click="version.show = !version.show"
                >
                  <span v-if="!version.show">Ver</span>
                  <span v-else>Ocultar</span>
                  ({{ version.items.length }}) items
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-loading v-else />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListTask',
  data() {
    return {
      loading: false,
      boxedit: false,
      view: {
        entity: 'budget',
        id: this.$route.params.id,
      },
      budgetCurrentItem: {},
      budgetCurrentItem: this.defineBudgetItem(),
      budgetitems: [],
      version: this.defineBudget(),
      subtotal: 0,
      subtotal_internal: 0,
      total: 0,
      checked: false,
      createNewVersion: false,
      selectedSocialReason: null,
      current: {},
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getAccountCountries',
      socialreasons: 'getSocialReasons',
      suppliers: 'getSuppliers',
      accounts: 'getAccounts',
      budgets: 'getBudgets',
      budget: 'getBudget',
      campaigns: 'getCampaigns',
      user: 'getUser',
      projects: 'getProjects',
      elements: 'getBudgetElements',
      clients: 'getClients',
      ejecutives: 'getUsers',
    }),
    filteredAccounts() {
      return this.accounts.filter((account) => {
        if (
          account.social_reason_id == this.current.social_reason_id ||
          account.social_reason_id == this.current.social_reason_id
        ) {
          return account
        }
      })
    },
    filteredProjects() {
      return this.projects.filter((project) => {
        if (
          project.account_id == this.current.account_id ||
          project.account_id == this.current.account_id
        ) {
          return project
        }
      })
    },
    filteredCampaigns() {
      return this.campaigns.filter((campaign) => {
        if (
          campaign.project_id == this.current.project_id ||
          campaign.project_id == this.current.project_id
        ) {
          return campaign
        }
      })
    },
    filteredBudgetElements() {
      return this.elements.filter((element) => {
        if (
          element.account_id == this.current.account_id ||
          element.account_id == this.current.account_id
        ) {
          return element
        }
      })
    },
    filteredEjecutives() {
      return this.ejecutives.filter((ejecutive) => {
        if ([4, 5].includes(ejecutive.team_id)) {
          return ejecutive
        }
      })
    },
    taxSubtotal() {
      return this.budgetitems.reduce(
        (acc, item) =>
          acc +
          this.percentCalculator(item.iva, item.quantity * item.unit_value),
        0
      )
    },
    commissionSubtotal() {
      return this.budgetitems.reduce(
        (acc, item) =>
          acc +
          this.percentCalculator(
            item.commission,
            item.quantity * item.unit_value
          ),
        0
      )
    },
  },
  async beforeMount() {
    try {
      await this.getAll('socialreason')
      await this.getList('project')
      await this.getList('campaign')
      await this.getList('budgetstate')
      await this.getList('budgetelement')

      await this.getAll('supplier')
      await this.getList('accountcountry')
      await this.getList('account')
      await this.getList('budget')
      await this.getList('client')
      await this.getList('user')
      await this.lookCurrentBudget(), (this.loading = true)

      this.current = await JSON.parse(JSON.stringify(this.budget))
      await this.selectSocialReason()

      this.budgetitems = this.current.versions[0].items
      this.current.usd_subtotal = this.current.versions[0].usd_subtotal
      this.current.usd_total = this.current.versions[0].usd_total
    } catch (error) {}
  },
  methods: {
    updateSocialReasonConvertion(response) {
      const { money_code, usd_convertion, updated_conversion } = response

      this.current.money_code = money_code
      this.current.usd_convertion = usd_convertion
      this.current.updated_conversion = updated_conversion
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    percentCalculator(percent, value, totalIncludePercent = false) {
      if (percent) {
        let ivaDecimal = totalIncludePercent
          ? (100 + percent) / 100
          : percent / 100
        return ivaDecimal * value
      }

      if (totalIncludePercent) {
        return value
      }

      return 0
    },
    async lookCurrentBudget() {
      try {
        await this.show(this.view)

        this.loading = true
      } catch (error) {}
    },
    defineBudget: () => ({
      name: '',
      number: '',
      date: '',
      entity: 'budget',
      path: '',
      created_by: null,

      reference: null,
      type: null,

      country_id: null,
      social_reason_id: null,
      account_id: null,
      project_id: null,
      campaign_id: null,

      money_code: null,
      iva: 0,
      usd_convertion: null,
      updated_conversion: null,

      usd_subtotal: 0,
      usd_total: 0,
    }),
    defineBudgetItem: () => ({
      id: null,
      quantity: 1,
    }),
    checkBudget() {
      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados')
        return
      }

      if (!this.current.usd_convertion) {
        window.$toast.info('Actualice las conversiones en la seccion de paises')
        return
      }

      this.checked = true
    },
    createVersion() {
      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados')
        return
      }

      let vm = this
      vm.current.created_by = this.user.id
      vm.current.items = this.budgetitems

      vm.current.subtotal = this.subtotal
      vm.current.subtotal_internal = this.subtotal_internal
      vm.current.total = this.total
      vm.current.total_internal = this.total_internal
      vm.current.iva = this.taxSubtotal
      vm.current.commission = this.commissionSubtotal
      vm.current.usd_tax = this.taxSubtotal / vm.current.usd_convertion
      vm.current.usd_commission =
        this.commissionSubtotal / vm.current.usd_convertion
      vm.current.entity = 'budget'
      vm.update(vm.current)
        .then((item) => {
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/business/budgets'
          )
        })
        .catch((error) => {
          console.log('FAILURE!!')
        })
        .finally(() => {
          vm.loading = true
          //this.defineBudget()
        })
    },
    addItem() {
      let item = this.elements.find(
        (element) => element.id == this.budgetCurrentItem.id
      )

      let object = {
        name: item ? item.name : 'Titulo',
        description: null,
        quantity: parseInt(this.budgetCurrentItem.quantity),
        unit_value: item ? item.value : 0,
        unit_value_internal: item ? item.value : 0,
        iva: 0,
        commission: 0,
        total: null,
        supplier_id: null,
      }
      this.budgetitems.push(object)

      this.budgetCurrentItem = this.defineBudgetItem()
    },
    async selectSocialReason() {
      let response = this.socialreasons.find(
        (socialreason) => socialreason.id == this.current.social_reason_id
      )

      if (response) {
        this.updateSocialReasonConvertion(response)
        this.selectedSocialReason = response
      } else {
        return {}
      }
    },
    ...mapActions(['show', 'getAll', 'getList', 'store', 'update']),
  },
  watch: {
    budgetitems: {
      deep: true,

      handler(value) {
        this.subtotal = 0
        this.total = 0
        this.total_internal = 0
        this.budgetitems.forEach((item) => {
          this.subtotal += item.quantity * item.unit_value
          this.subtotal_internal += item.quantity * item.unit_value_internal
          this.total +=
            item.quantity * item.unit_value +
            this.percentCalculator(
              item.iva,
              item.quantity * item.unit_value,
              false
            ) +
            this.percentCalculator(
              item.commission,
              item.quantity * item.unit_value,
              false
            )
          this.total_internal +=
            item.quantity * item.unit_value_internal +
            this.percentCalculator(
              item.iva,
              item.quantity * item.unit_value_internal,
              false
            ) +
            this.percentCalculator(
              item.commission,
              item.quantity * item.unit_value_internal,
              false
            )
        })

        this.version.usd_subtotal = this.version.usd_convertion * this.subtotal
        this.version.usd_total = this.version.usd_convertion * this.total
      },
    },
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// ShowBudget.vue?3e1b9121